import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

export const reportItems: (keyof typeof UploadFileTypesEnum)[] = [
  'KNM_STATISTICS_BY_SUPERVISION_TYPE',
  'UNPLANNED_KNM_STATISTICS_BY_KNO',
  'UNPLANNED_KNM_STATISTICS_BY_PROSECUTOR_AND_KNO',
  'UNPLANNED_KNM_STATISTICS_BY_PROSECUTOR',
  'PLANNED_KNM_STATISTICS_BY_PROSECUTOR_AND_KNO',
  'PLANNED_KNM_STATISTICS_BY_PROSECUTOR',
  'PLANNED_KNM_STATISTICS_BY_OPF',
  'PLANNED_KNM_STATISTICS_BY_REJECT_REASON',
  'SPV_AND_TOR_REGISTER',
  'TOSER_AND_SEZ_REGISTER',
  'UNTIMELY_FILLED',
  'RESULT_IS_ABSENT_OR_LATE',
  'DECISION_APPEALED',
  'VIOLATIONS_DETECTED',
  'PRESCRIPTIONS_FULFILLED',
  'PLANNED_FOR_MONTH',
  'COMPLETED_WITHIN_MONTH',
  'APPROVED_KNM_PLAN',
  'KNM_FROM_SMEV_START_DATE',
  'KNM_FROM_SMEV_RECEIVED_DATE',
  'RESULT_KNM_BY_PROSECUTOR_AND_KNO',
  'VIOLATIONS_KNM_BY_PROSECUTOR_AND_KNO',
];
